import { createReducer, createSelector } from '@reduxjs/toolkit';
import {
  getAllHearingTypesSuccess,
  getAllHearingsSuccess,
  getAllHearingTemplatesSuccess,
  getHearingSuccess,
} from '../actions/api';
import {
  getIncludedData,
  selectAllFromApiState,
} from '../helpers/selectorHelpers';
import { updateDtoList } from '../helpers/reducerHelpers';
import { getAttr, getEntityId, getRelId } from '../helpers/apiHelpers';
import { VALIDATION_RULE } from '../../constants/api';
import { fieldByIdSelector } from './fieldSlice';

// -------- Overview --------
// -------- Reducer --------
const validationRuleReducer = createReducer(
  {
    all: [],
  },
  (builder) => {
    builder
      .addCase(getAllHearingTypesSuccess, (state, action) => {
        const data = getIncludedData(action);
        const validationRules = data.filter(
          (include) => include.type === VALIDATION_RULE,
        );
        return updateDtoList(state, 'all', validationRules);
      })
      .addCase(getAllHearingsSuccess, (state, action) => {
        const data = getIncludedData(action);
        const validationRules = data.filter(
          (include) => include.type === VALIDATION_RULE,
        );
        return updateDtoList(state, 'all', validationRules);
      })
      .addCase(getHearingSuccess, (state, action) => {
        const data = getIncludedData(action);
        const validationRules = data.filter(
          (include) => include.type === VALIDATION_RULE,
        );
        return updateDtoList(state, 'all', validationRules);
      })
      .addCase(getAllHearingTemplatesSuccess, (state, action) => {
        const data = getIncludedData(action);
        const validationRules = data.filter(
          (include) => include.type === VALIDATION_RULE,
        );
        return updateDtoList(state, 'all', validationRules);
      });
  },
);

// -------- Selectors --------
const selectGetAllValidationRules = (state) =>
  selectAllFromApiState(state, 'validationRule');
const allValidationRuleSelector = createSelector(
  selectGetAllValidationRules,
  (validationRules) => validationRules,
);

const validationRuleByFieldId = (fieldId) =>
  createSelector(
    [allValidationRuleSelector, fieldByIdSelector(fieldId)],
    (validationRules, field) =>
      validationRules.find(
        (v) => getRelId(field, 'validationRule') === getEntityId(v),
      ),
  );

const validationRuleByFieldType = (fieldType) =>
  createSelector([allValidationRuleSelector], (validationRules) =>
    validationRules.find((v) => getAttr(v, 'fieldType') === fieldType),
  );

export {
  allValidationRuleSelector,
  validationRuleByFieldId,
  validationRuleByFieldType,
};

export default validationRuleReducer;
